/**
 * View component for /audit-logs
 *
 * Generic auditLog list view. Defaults to 'all' with:
 * this.props.dispatch(auditLogActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes, { object } from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as auditLogActions from '../auditLogActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

import auditLogUtils from '../../../global/utils/auditLogUtils';

import * as certificateTemplateActions from '../../certificateTemplate/certificateTemplateActions';
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as sceneActions from '../../scene/sceneActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as studyRoleActions from '../../studyRole/studyRoleActions';
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as courseActions from '../../course/courseActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userActions from '../../user/userActions';

// added 1.17
import * as nodeActions from '../../node/nodeActions';
import * as siteActions from '../../site/siteActions';
import * as siteLocationActions from '../../siteLocation/siteLocationActions';
import * as evaluationActions from '../../evaluation/evaluationActions';
import * as questionActions from '../../question/questionActions';
import * as answerActions from '../../answer/answerActions';

// added 1.19
import * as metricActions from '../../metric/metricActions';
import * as metricCategoryActions from '../../metricCategory/metricCategoryActions';

// added 1.29
import * as sentimentQuestionActions from '../../sentimentQuestion/sentimentQuestionActions';

// import resource components
import AuditLogLayout from '../components/AuditLogLayout.js.jsx';
import AuditLogListItem from '../components/AuditLogListItem.js.jsx';

class AuditLogList extends Base {
  constructor(props) {
    super(props);
    this.state = {
      resourceName: auditLogUtils.parseResourceName(this.props.match.params.targetType, "variable")
      , modelName: auditLogUtils.parseResourceName(this.props.match.params.targetType, "model")
    }

  }

  componentDidMount() {
    // this is intended to be super generic for the time being
    // arbitrary list, simple ui. this will probably suffice for 
    // simpler objects, while some of the more intense ones will
    // need more customization

    const { resourceName, modelName } = this.state;

    if(this.props.match.params.targetType && this.props.match.params.targetId) {
      // fetch single target
      // let resourceName = auditLogUtils.parseResourceName(this.props.match.params.targetType, "variable");
      // let ModelName = auditLogUtils.parseResourceName(this.props.match.params.targetType, "model");
      let newResourceName = 
      resourceName == 'group' ? 'study' 
      : resourceName == 'groupUser' ? 'studyUser' 
      : resourceName == 'groupRole' ? 'studyRole' 
      : resourceName == 'certificate' ? 'moduleCertificate'
      : resourceName; 

    let newModelName = 
      modelName == 'Study' ? 'Group' 
      : modelName == 'StudyUser' ? 'GroupUser' 
      : modelName == 'StudyRole' ? 'GroupRole' 
      : modelName == 'TrainingModule' ? 'ContentModule' 
      : modelName == 'Sponsor' ? 'Organization' 
      : modelName == 'ModuleCertificate' ? 'Certificate' 
      : modelName;

      this.props.dispatch(eval(newResourceName + "Actions").fetchSingleIfNeeded(this.props.match.params.targetId))

      // fetch all audit logs for this target
      this.props.dispatch(auditLogActions.fetchListIfNeeded("targetType", newModelName, "targetId", this.props.match.params.targetId))

      // fetch users for this list with custom api
      this.props.dispatch(userActions.fetchListIfNeeded("auditLogTarget", newModelName, "targetId", this.props.match.params.targetId))

    }

    // fetch a list of your choice
    // this.props.dispatch(auditLogActions.fetchListIfNeeded('all')); // defaults to 'all'
  }

  render() {
    const { auditLogStore, userStore } = this.props;
    const { resourceName, modelName } = this.state;
    
    let newResourceName = 
      resourceName == 'group' ? 'study' 
      : resourceName == 'groupUser' ? 'studyUser' 
      : resourceName == 'groupRole' ? 'studyRole' 
      : resourceName == 'certificate' ? 'moduleCertificate'
      : resourceName; 

      let newModelName = 
      modelName == 'Study' ? 'Group' 
      : modelName == 'StudyUser' ? 'GroupUser' 
      : modelName == 'StudyRole' ? 'GroupRole' 
      : modelName == 'TrainingModule' ? 'ContentModule' 
      : modelName == 'Sponsor' ? 'Organization' 
      : modelName == 'ModuleCertificate' ? 'Certificate' 
      : modelName;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the auditLogList meta info here so we can reference 'isFetching'
    const auditLogList = auditLogStore.util.getListInfo("targetType", newModelName, "targetId", this.props.match.params.targetId);

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual auditLog objetcs
     */
    const auditLogListItems = auditLogStore.util.getList("targetType", newModelName, "targetId", this.props.match.params.targetId);

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = (
      !auditLogListItems
      || !auditLogList
      || auditLogListItems && auditLogListItems.length == 0 
    );

    const isFetching = (
      !auditLogListItems
      || !auditLogList
      || auditLogList.isFetching
    )

    return (
      <AuditLogLayout>
        <Helmet
          title={"Audit Log List | Pro-ficiency"}
        />
        <h1> Audit Log List </h1>
        <p>Intended to be a very simple way to view logs for a single object.</p>
        <hr/>
        <br/>
        <h3>Viewing logs for {newModelName}: {this.props.match.params.targetId}</h3>
        {/* <Link to={'/audit-logs/new'}> New Audit Log </Link> */}
        <br/>
        { isEmpty ?
          (isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
          :
          <div style={{ opacity: isFetching ? 0.5 : 1 }}>
            <div>
              {auditLogListItems.map((auditLog, i) =>
                <AuditLogListItem key={auditLog._id + i} auditLog={auditLog} />
              )}
            </div>
          </div>
        }
      </AuditLogLayout>
    )
  }
}

AuditLogList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    answerStore: store.answer
    , auditLogStore: store.auditLog
    , certificateTemplateStore: store.certificateTemplate
    , courseStore: store.course
    , evaluationStore: store.evaluation
    , sentimentQuestionStore: store.sentimentQuestion
    , metricStore: store.metric
    , metricCategoryStore: store.metricCategory
    , moduleCertificateStore: store.moduleCertificate
    , nodeStore: store.node
    , questionStore: store.question
    , sceneStore: store.scene
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , studyRoleStore: store.studyRole
    , studyUserStore: store.studyUser
    , siteStore: store.site
    , siteLocationStore: store.siteLocation
    , contentModuleStore: store.contentModule
    , userStore: store.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AuditLogList)
);



// WEBPACK FOOTER //
// modules/auditLog/views/AuditLogList.js.jsx